<template>
  <transition name="fade">
    <div v-if="showProgressBar" class="progress-bar-wrapper" :style="{ backgroundColor: primaryColor }">
      <div class="text">{{ messages.progressMessage }}</div>
      <div class="progress-bar">
        <span class="progress" :style="{ width: progress, background: primaryColor }" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { tween } from 'shifty'

import { logger } from '../../../common'

export default {
  data: function () {
    return {
      animatedProgress: 0
    }
  },
  computed: {
    ...mapGetters(['primaryColor', 'showProgressBar']),
    ...mapState(['messages']),
    fontFamily () {
      return this.headerFont
    },
    progress () {
      return `${this.animatedProgress}%`
    }
  },
  watch: {
    'messages.progressPercent' (newValue: number) {
      if (isNaN(newValue) || newValue === '' || newValue === undefined) return
      if (this.animatedProgress === undefined) return

      tween({
        from: { progress: this.animatedProgress },
        to: { progress: newValue },
        duration: 1000,
        easing: 'easeOutQuad',
        step: state => {
          this.animatedProgress = state.progress
        }
      }).catch((err) => {
        logger.error(err)
      })
    }
  },
  mounted () {
    this.animatedProgress = this.messages.progressPercent
  }
}
</script>

<style src="./progress-bar.scss" />
